
export default {
  install(app) {
    console.log('install selectCustomer')
    app.config.globalProperties.$selectCustomer = {
      run: (router, params) => {
        console.log('run selectCustomer')
        return new Promise((res, rej) => {
          const spaceName = "/selectCustomer" ;
          router.push({
              path:spaceName,
              state:({
                spaceName,
                ...params
              })
          })
          window[spaceName] = {res,rej};
        });
      },
    };
  },
};

